import { render } from "preact";
import { App } from "./app/App";
import "./styles.css";
render(<App />, document.getElementById("app")!);
